declare const window: any;

import * as React from 'react';
import { API_URL } from '@src/shared/src/const/api';
import { useDispatch } from 'react-redux';
import { adminUserActions } from '@src/shared/src/actions';
import { cond } from '@src/shared/src/util/general';
import { baseErrorCond } from '@toolkit/util/app';

type ConciergeLinkProps = React.PropsWithChildren<{
  className?: string;
  formType?: string;
}>;

export const ConciergeLink = ({ className, formType, children }: ConciergeLinkProps) => {
  const dispatch = useDispatch();

  const handleServiceClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const url = `${API_URL.ZENDESK_SSO}?form_type=${formType}`;

    if (window.__IS_WEBVIEW) {
      window.isMobileWebView.postMessage('concierge_loading');

      dispatch(
        adminUserActions.fetchOneTimeLoginTokenAsync.request({
          onSuccess: (token) => window.location.replace(`${url}&browser=true&login_token=${token}`),
          onError: cond(baseErrorCond),
        }),
      );
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <a className={className} href="#" onClick={handleServiceClick}>
      {children}
    </a>
  );
};
